import cx from 'classnames'
import { memo } from 'react'
import Image from 'next/image'
import { Href } from 'components/navigation'
import { useMedia } from 'src/contexts/device'

// Image sources for different logo variants
const LOGO_IMAGES = {
  mobile: '/images/logo-mob.webp',
  desktop: '/images/logo.webp',
  secondary: '/images/logo.webp',
} as const

const LOGO_DIMENSIONS = {
  mobilePrimary: { width: 38.742, height: 22.177 },
  standard: { width: 105.93, height: 22.177 },
} as const

interface LogoProps {
  className?: string
  isSecondary?: boolean
}

const Logo = memo<LogoProps>(({ className, isSecondary = false }) => {
  const { isMobileView } = useMedia()

  const getImageSource = () => {
    if (isSecondary) {
      return LOGO_IMAGES.secondary
    }

    return isMobileView ? LOGO_IMAGES.mobile : LOGO_IMAGES.desktop
  }

  const getDimensions = () => {
    if (isMobileView && !isSecondary) {
      return LOGO_DIMENSIONS.mobilePrimary
    }

    return LOGO_DIMENSIONS.standard
  }

  const imageSrc = getImageSource()
  const dimensions = getDimensions()

  return (
    <Href to="/" className={cx('flex items-center', className)}>
      <Image
        src={imageSrc}
        alt="Logo"
        width={dimensions.width}
        height={dimensions.height}
        priority
      />
    </Href>
  )
})

Logo.displayName = 'Logo'

export default Logo
